/** @file Live ports of the curve editor: the shown document and the editor command path. */
import { dispatch } from '../../api/sync/dispatch';
import { pushNotice } from '../../api/sync/pushNotice';
import { currentDoc } from '../../stores/currentDoc';
import { docStore } from '../../stores/docStore';
import type { CurvePorts } from './curvePorts';

/** What CurvesTab passes to CurvesView; the command path applies optimistically, keeps undo and shows failures. */
export const curvePortsLive: CurvePorts = {
  /** The confirmed document with this client's pending commands replayed on top, or null while none is open. */
  doc: () => currentDoc(docStore.getState()),
  /** One batch = one commit = one undo step; a local refusal becomes an Activity notice (a server refusal already is one). */
  commit: (calls) => {
    if (calls.length === 0) return;
    try {
      dispatch([...calls]).done.catch(() => undefined);
    } catch (thrown) {
      pushNotice([...calls], thrown);
    }
  },
};
